export const SIDEBAR_SUCCESS = "SIDEBAR_SUCCESS";
export const SIDEBAR_CLEAR = "SIDEBAR_CLEAR";
